import { findKey } from 'lodash'
import sexes from '@/lib/options/sexes-livestock'

export default sex => {
  return findKey(sexes, sexParent => findKey(sexParent, sexChild => sexChild.value === sex))
}
